import i18next from "i18next"
import { useTranslation } from "react-i18next"
import { KTSVG } from "src/_metronic/helpers"
import { PopoverText } from "src/components"
import { PriceFormater } from "src/components/mikro/PriceFormater"

type Prop = {
    sektorID: any
    retailFlag: any
    handleShowValue: any
    removeSubOrder: any
    setShow3: any
    setSubID: any
    formattingTon: any
    setProductName: any
    setCityName: any
    setProvinceName: any
    setIDSector: any
    setSubOrderID: any
    setParam: any
    setFileBox: any
    setShowUpload: any
    setShow1: any
    setDetailOrder: any
    addedOrder: any
    ambilAttachment: any
    setIsLoadingModal: any
    approveFlag: any
    canUpdate?: boolean
    onlyAttachment?: boolean
}

const ApprovalSIPDetailTable: React.FC<Prop> = ({
    sektorID,
    retailFlag,
    handleShowValue,
    removeSubOrder,
    setShow3,
    setSubID,
    formattingTon,
    setProductName,
    setCityName,
    setProvinceName,
    setIDSector,
    setSubOrderID,
    setParam,
    setFileBox,
    setIsLoadingModal,
    setShowUpload,
    setShow1,
    setDetailOrder,
    addedOrder,
    ambilAttachment,
    approveFlag,
    canUpdate,
    onlyAttachment = false,
}) => {
    const {t} = useTranslation()

    return (
        <>
            <div className='table-responsive mt-5 bdr'>
                {/* Table Head */}
                <table className='table table-row-dashed table-row-gray-300 align-middle gs-0 gy-4'>
                <thead>
                    <tr className='fw-bold d-flex jusify-content-center w-100 align-items-center'>
                    <th className='td-order-2 text-center'>{t('kontrak-item')}</th>
                    <th className='td-order-3 text-center'>Status</th>
                    <th className='td-order-3 text-center'>{t('kontrak-aksi')}</th>
                    <th className='td-order-4 text-center'>Sales Org</th>
                    <th className='td-order-2 text-center'>{t('kontrak-incoterm')}</th>
                    <th className='td-order-4 text-center'>{t('kontrak-wilayah')}</th>
                    {sektorID == '1' ? (
                        <th className='td-order-2 text-center'>{t('segment')}</th>
                    ) : (
                        ''
                    )}
                    <th className='td-order-3 text-center'>{t('End Customer')}</th>
                    {sektorID != '2' ? '' : <th className='td-order-2 text-center'>{t('Sektor')}</th>}
                    <th className='td-order-2 text-center'>{t('kontrak-jenis')}</th>
                    <th className='td-order-2 text-center'>{t('Product Code')}</th>
                    <th className='td-order-4 text-center'>{t('kontrak-nama')}</th>
                    <th className='td-order-3 text-center'>{t('kontrak-spek')}</th>
                    {retailFlag == 'AR03' ? (
                        <>
                        <th className='td-order-2 text-center'>{t('Submission Quantum')}</th>
                        {sektorID != '2' ? (
                            <th className='td-order-2 text-center'>{t('sub-order-kuantumD')}</th>
                        ) : (
                            ''
                        )}
                        <th className='td-order-2 text-center'>{t('sub-order-hargaP')}</th>
                        {sektorID != '2' ? (
                            <th className='td-order-2 text-center'>{t('sub-order-hargaD')}</th>
                        ) : (
                            ''
                        )}
                        </>
                    ) : (
                        <>
                        <th className='td-order-2 text-center'>{t('Submission Quantum')}</th>
                        {sektorID != '2' ? (
                            <th className='td-order-2 text-center'>{t('sub-order-kuantumD')}</th>
                        ) : (
                            ''
                        )}
                        <th className='td-order-2 text-center'>{t('sub-order-hargaP')}</th>
                        {sektorID != '2' ? (
                            <th className='td-order-2 text-center'>{t('sub-order-hargaD')}</th>
                        ) : (
                            ''
                        )}
                        </>
                    )}
                    {sektorID == '1' && (
                        <th className='td-order-2 text-center'>Status {t('Price')}</th>
                    )}
                    {sektorID == '2' ? (
                        <th className='td-order-2 text-center'>{t('kontrak-Gudang')}</th>
                    ) : (
                        ''
                    )}
                    </tr>
                </thead>
                {addedOrder.map((data: any, _index: any) => (
                    <>
                    <tbody>
                        <tr className='d-flex jusify-content-center w-100 align-items-center'>
                        <td className='td-order-2 text-center column'>
                            <span className='d-block fs-6 py-3'>{_index + 1}</span>
                        </td>
                        <td className='td-order-3 text-center column'>
                            <span className='d-block fs-6 py-3'>
                                {data['status_sip'] === 1 ? (
                                    <span className='badge badge-light-primary'>
                                    {t(data['status_text_sip'])}
                                    </span>
                                ) : data['status_sip'] === 2 ? (
                                    <span className='badge badge-light-warning'>
                                    {t(data['status_text_sip'])}
                                    </span>
                                ) : data['status_sip'] === 3 ? (
                                    <span className='badge badge-light-primary'>
                                    {t(data['status_text_sip'])}
                                    </span>
                                ) : data['status_sip'] === 4 ? (
                                    <span className='badge badge-light-success'>
                                    {t(data['status_text_sip'])}
                                    </span>
                                ) : data['status_sip'] === 5 ? (
                                    <span className='badge badge-light-success'>
                                    {t(data['status_text_sip'])}
                                    </span>
                                ) : data['status_sip'] === 6 ? (
                                    <span className='badge badge-light-primary'>
                                    {t(data['status_text_sip'])}
                                    </span>
                                ) : data['status_sip'] === 7 ? (
                                    <span className='badge badge-light-warning'>
                                    {t(data['status_text_sip'])}
                                    </span>
                                ) : data['status_sip'] === 8 ? (
                                    <span className='badge badge-light-primary'>
                                    {t(data['status_text_sip'])}
                                    </span>
                                ) : data['status_sip'] === 9 ? (
                                    <span className='badge badge-light-warning'>
                                    {t(data['status_text_sip'])}
                                    </span>
                                ) : (
                                    <>
                                        {data['status'] === 1 ? (
                                            <span className='badge badge-light-primary'>
                                            {t(data['status_text'])}
                                            </span>
                                        ) : data['status'] === 2 ? (
                                            <span className='badge badge-light-warning'>
                                            {t(data['status_text'])}
                                            </span>
                                        ) : data['status'] === 3 ? (
                                            <span className='badge badge-light-primary'>
                                            {t(data['status_text'])}
                                            </span>
                                        ) : data['status'] === 4 ? (
                                            <span className='badge badge-light-success'>
                                            {t(data['status_text'])}
                                            </span>
                                        ) : data['status'] === 5 ? (
                                            <span className='badge badge-light-success'>
                                            {t(data['status_text'])}
                                            </span>
                                        ) : data['status'] === 6 ? (
                                            <span className='badge badge-light-primary'>
                                            {t(data['status_text'])}
                                            </span>
                                        ) : data['status'] === 7 ? (
                                            <span className='badge badge-light-warning'>
                                            {t(data['status_text'])}
                                            </span>
                                        ) : data['status'] === 8 ? (
                                            <span className='badge badge-light-primary'>
                                            {t(data['status_text'])}
                                            </span>
                                        ) : data['status'] === 9 ? (
                                            <span className='badge badge-light-warning'>
                                            {t(data['status_text'])}
                                            </span>
                                        ) : (
                                            <span className='badge badge-light-warning'>
                                                {t(data['status_text'])}
                                            </span>
                                        )}
                                    </>
                                )}
                            </span>
                        </td>
                        <td className='td-order-3 column'>
                            <div
                            className='d-flex justify-content-center align-items-center'
                            style={{margin: '1.25px 0'}}
                            >
                            { !onlyAttachment && <button
                                onClick={(e: any) => {
                                setDetailOrder(data)
                                // e.preventDefault()
                                // setSales(data.sales_org_code)
                                // setCity(data.city?.id)
                                // setMatNumber(data.material_number)
                                setShow1(true)
                                }}
                                className='btn btn-icon btn-bg-light btn-active-color-primary btn-sm me-1'
                                data-bs-toggle='tooltip'
                                data-bs-placement='top'
                                data-bs-trigger='hover'
                                title='Detail'
                            >
                                <KTSVG
                                path='/media/icons/duotune/file-text-fill.svg'
                                className='svg-icon-3'
                                />
                            </button> }
                            <button
                                className='btn btn-icon btn-bg-light btn-active-color-primary btn-sm me-1'
                                data-bs-toggle='tooltip'
                                data-bs-placement='top'
                                data-bs-trigger='hover'
                                title={t('order-lampiran')}
                                onClick={(e: any) => {
                                    setIsLoadingModal(true)
                                    setShowUpload(true)
                                    setFileBox(data)
                                    setSubOrderID(
                                      data.order_sub_item_id == null
                                        ? data.id
                                        : data.order_sub_item_id
                                    )
                                    ambilAttachment(
                                      data.order_sub_item_id == null
                                        ? data.id
                                        : data.order_sub_item_id
                                    , 'order-item')
                                    setIDSector(data?.sector?.id)
                                }}
                            >
                                <KTSVG
                                path='/media/icons/duotune/archive-fill.svg'
                                className='svg-icon-3'
                                />
                            </button>
                            { !onlyAttachment && <button
                                onClick={(e: any) => {
                                // e.preventDefault()
                                setIDSector(data.sector_id)
                                setProvinceName(data.province?.region_name)
                                setCityName(data.city?.city_name)
                                setProductName(data.product_name)
                                formattingTon(data.fixed_quantum)
                                setSubID(data.order_sub_item_id || data.id)
                                setShow3(true)
                                }}
                                className='btn btn-icon btn-bg-light btn-active-color-primary btn-sm me-1'
                                data-bs-toggle='tooltip'
                                data-bs-placement='top'
                                data-bs-trigger='hover'
                                title={t('Jadwal')}
                            >
                                <KTSVG
                                path='/media/icons/duotune/calendar-check-fill.svg'
                                className='svg-icon-3'
                                />
                            </button> }
                            { (canUpdate && !onlyAttachment) &&
                            <button
                                className='btn btn-icon btn-bg-light btn-active-color-primary btn-sm'
                                data-bs-toggle='tooltip'
                                data-bs-placement='top'
                                data-bs-trigger='hover'
                                title={t('Hapus')}
                                onClick={(e: any) => {
                                // e.preventDefault()
                                removeSubOrder(_index)
                                }}
                            >
                                <KTSVG
                                path='/media/icons/duotune/trash-fill.svg'
                                className='svg-icon-3'
                                />
                            </button>
                            }
                            </div>
                        </td>
                        <td className='td-order-4 text-center column'>
                            <span className='d-block fs-6 py-3'>{data.produsen?.name}</span>
                        </td>
                        {data.sector?.id == 2 ? (
                            <>
                            {data.incoterm2 == null ? (
                                <td className='td-order-2 text-center column'>
                                <span className='d-block fs-6 py-3'>
                                    {data.incoterm1?.code}-{data.incoterm2_id}
                                </span>
                                </td>
                            ) : (
                                <td className='td-order-2 text-center column'>
                                <span className='d-block fs-6 py-3'>
                                    {data.incoterm1?.code}-{data.incoterm2?.code}
                                </span>
                                </td>
                            )}
                            </>
                        ) : (
                            <>
                            {data.incoterm2 == null ? (
                                <td className='td-order-2 text-center column'>
                                <span className='d-block fs-6 py-3'>
                                    {data.incoterm1?.code}
                                    {data.incoterm2_id == null || data.incoterm2_id == '0'
                                    ? ''
                                    : '-' + data.incoterm2_id}
                                </span>
                                </td>
                            ) : (
                                <td className='td-order-2 text-center column'>
                                <span className='d-block fs-6 py-3'>
                                    {data.incoterm1?.code}-{data.incoterm2?.code}
                                </span>
                                </td>
                            )}
                            </>
                        )}

                        <td className='td-order-4 text-center column'>
                            <span className='d-block fs-6 py-3'>
                            <PopoverText
                                content={
                                data.province?.region_name ||
                                '' + (data.city?.city_name ? ', ' + data.city?.city_name : '')
                                }
                                index={_index}
                                className='spec-sliceee'
                            />
                            </span>
                        </td>

                        {sektorID == '1' ? (
                            <td className='td-order-2 text-center column'>
                            <span className='d-block fs-6 py-3'>{t(data.segment_name)}</span>
                            </td>
                        ) : (
                            ''
                        )}
                        <td className='td-order-3 text-center column'>
                            <span className='d-block fs-6 py-3'>
                            <PopoverText
                                content={
                                data?.end_user_multiple
                                    ? handleShowValue(data.end_user)
                                    : data.end_user
                                }
                                index={_index}
                                className='desc-slicee'
                            />
                            </span>
                        </td>
                        {sektorID != '2' ? (
                            ''
                        ) : (
                            <td className='td-order-2 text-center column'>
                            <span className='d-block fs-6 py-3'>{t(data.sector?.name)}</span>
                            </td>
                        )}
                        <td className='td-order-2 text-center column'>
                            <span className='d-block fs-6 py-3'>{data.product_type_desc}</span>
                        </td>
                        <td className='td-order-2 text-center column'>
                            <span className='d-block fs-6 py-3'>
                            {parseInt(data.material_number) == 0
                                ? ''
                                : data.material_number?.slice(-7)}
                            </span>
                        </td>
                        <td className='td-order-4 text-center column'>
                            <span className='d-block fs-6 py-3'>{data.product_name}</span>
                        </td>
                        <td className='td-order-3 text-center column'>
                            <span className='d-block fs-6 py-3'>
                            <PopoverText
                                content={data.product_spec || '-'}
                                index={_index}
                                className='spec-sliceee'
                            />
                            </span>
                        </td>
                        {retailFlag == 'AR03' ? (
                            <>
                            {data.sector_id != 2 ? (
                                <td className='td-order-2 text-center column'>
                                <span className='d-block fs-6 py-3'>
                                    {i18next.language === 'en'
                                    ? data.request_quantum?.toLocaleString('en', {
                                        maximumFractionDigits: 4,
                                        })
                                    : data.request_quantum?.toLocaleString('id', {
                                        maximumFractionDigits: 4,
                                        })}{' '}
                                    {data.sector_id === 3 ? 'MT' : 'Ton'}
                                </span>
                                </td>
                            ) : (
                                <></>
                            )}

                            <td className='td-order-2 text-center column'>
                                <span className='d-block fs-6 py-3'>
                                {i18next.language === 'en'
                                    ? data.fixed_quantum?.toLocaleString('en', {
                                        maximumFractionDigits: 4,
                                    })
                                    : data.fixed_quantum?.toLocaleString('id', {
                                        maximumFractionDigits: 4,
                                    })}{' '}
                                {data.sector_id === 3 ? 'MT' : 'Ton'}
                                </span>
                            </td>

                            {data.sector_id != 2 && (
                                <>
                                {data.is_formulated_price ? (
                                    <>
                                    <td className='td-order-2 text-center column'>
                                        <span className='d-block fs-6 py-3'>
                                        {t('Formulated Price')}
                                        </span>
                                    </td>
                                    </>
                                ) : (
                                    <>
                                    {data.sector_id == 1 ? (
                                        <>
                                        <td className='td-order-2 text-center column'>
                                            <span className='d-block fs-6 py-3'>
                                            {(data.sector_id !== 3 ? 'Rp' : 'USD') +
                                                i18next.language ===
                                            'en'
                                                ? data.request_price?.toLocaleString('en', {
                                                    maximumFractionDigits: 4,
                                                })
                                                : data.request_price?.toLocaleString('id', {
                                                    maximumFractionDigits: 4,
                                                }) + (data.sector_id !== 3 ? '/Ton' : '/MT')}
                                            </span>
                                        </td>
                                        </>
                                    ) : (
                                        <>
                                        <td className='td-order-2 text-center column'>
                                            <span className='d-block fs-6 py-3'>
                                            USD {PriceFormater(data.request_price)} /MT
                                            </span>
                                        </td>
                                        </>
                                    )}
                                    </>
                                )}

                                {data.sector_id != 3 ? (
                                    <td className='td-order-2 text-center column'>
                                    <span className='d-block fs-6 py-3'>
                                        {(data.sector_id !== 3 ? 'Rp' : 'USD') +
                                        (i18next.language === 'en'
                                            ? data.fixed_price?.toLocaleString('en', {
                                                maximumFractionDigits: 4,
                                            })
                                            : data.fixed_price?.toLocaleString('id', {
                                                maximumFractionDigits: 4,
                                            })) +
                                        (data.sector_id !== 3 ? '/Ton' : '/MT')}
                                    </span>
                                    </td>
                                ) : (
                                    <td className='td-order-2 text-center column'>
                                    <span className='d-block fs-6 py-3'>
                                        USD {PriceFormater(data.fixed_price)} /MT
                                    </span>
                                    </td>
                                )}
                                </>
                            )}

                            {data.sector_id != 3 ? (
                                <td className='td-order-2 text-center column'>
                                <span className='d-block fs-6 py-3'>
                                    {(data.sector_id !== 3 ? 'Rp' : 'USD') + i18next.language === 'en'
                                    ? data.fixed_price?.toLocaleString('en', {
                                        maximumFractionDigits: 4,
                                        })
                                    : data.fixed_price?.toLocaleString('id', {
                                        maximumFractionDigits: 4,
                                        }) + (data.sector_id !== 3 ? '/Ton' : '/MT')}
                                </span>
                                </td>
                            ) : (
                                <td className='td-order-2 text-center column'>
                                <span className='d-block fs-6 py-3'>
                                    USD {PriceFormater(data.fixed_price)} /MT
                                </span>
                                </td>
                            )}
                            </>
                        ) : (
                            <>
                            {data.sector_id != 2 ? (
                                <td className='td-order-2 text-center column'>
                                <span className='d-block fs-6 py-3'>
                                    {i18next.language === 'en'
                                    ? data.request_quantum?.toLocaleString('en', {
                                        maximumFractionDigits: 4,
                                        })
                                    : data.request_quantum?.toLocaleString('id', {
                                        maximumFractionDigits: 4,
                                        })}{' '}
                                    {data.sector_id === 3 ? 'MT' : 'Ton'}
                                </span>
                                </td>
                            ) : (
                                <></>
                            )}

                            <td className='td-order-2 text-center column'>
                                <span className='d-block fs-6 py-3'>
                                {i18next.language === 'en'
                                    ? data.fixed_quantum?.toLocaleString('en', {
                                        maximumFractionDigits: 4,
                                    })
                                    : data.fixed_quantum?.toLocaleString('id', {
                                        maximumFractionDigits: 4,
                                    })}{' '}
                                {data.sector_id === 3 ? 'MT' : 'Ton'}
                                </span>
                            </td>

                            {data.sector_id != 2 && (
                                <>
                                {data.is_formulated_price ? (
                                    <>
                                    <td className='td-order-2 text-center column'>
                                        <span className='d-block fs-6 py-3'>
                                        {t('Formulated Price')}
                                        </span>
                                    </td>
                                    </>
                                ) : (
                                    <>
                                    {data.sector_id == 1 ? (
                                        <>
                                        <td className='td-order-2 text-center column'>
                                            <span className='d-block fs-6 py-3'>
                                            {(data.sector_id !== 3 ? 'Rp' : 'USD') +
                                                i18next.language ===
                                            'en'
                                                ? data.request_price?.toLocaleString('en', {
                                                    maximumFractionDigits: 4,
                                                })
                                                : data.request_price?.toLocaleString('id', {
                                                    maximumFractionDigits: 4,
                                                }) + (data.sector_id !== 3 ? '/Ton' : '/MT')}
                                            </span>
                                        </td>
                                        </>
                                    ) : (
                                        <>
                                        {data.sector_id == 1 ? (
                                            <>
                                            <td className='td-order-2 text-center column'>
                                                <span className='d-block fs-6 py-3'>
                                                {(data.sector_id !== 3 ? 'Rp' : 'USD') +
                                                    (i18next.language === 'en'
                                                    ? data.request_price?.toLocaleString('en', {
                                                        maximumFractionDigits: 4,
                                                        })
                                                    : data.request_price?.toLocaleString('id', {
                                                        maximumFractionDigits: 4,
                                                        })) +
                                                    (data.sector_id !== 3 ? '/Ton' : '/MT')}
                                                </span>
                                            </td>
                                            </>
                                        ) : (
                                            <>
                                            <td className='td-order-2 text-center column'>
                                                <span className='d-block fs-6 py-3'>
                                                USD {PriceFormater(data.request_price)} /MT
                                                </span>
                                            </td>
                                            </>
                                        )}
                                        </>
                                    )}
                                    </>
                                )}

                                {data.sector_id != 3 ? (
                                    <td className='td-order-2 text-center column'>
                                    <span className='d-block fs-6 py-3'>
                                        {(data.sector_id !== 3 ? 'Rp' : 'USD') +
                                        (i18next.language === 'en'
                                            ? data.fixed_price?.toLocaleString('en', {
                                                maximumFractionDigits: 4,
                                            })
                                            : data.fixed_price?.toLocaleString('id', {
                                                maximumFractionDigits: 4,
                                            })) +
                                        '/Ton'}
                                    </span>
                                    </td>
                                ) : (
                                    <td className='td-order-2 text-center column'>
                                    <span className='d-block fs-6 py-3'>
                                        USD {PriceFormater(data.fixed_price)} /MT
                                    </span>
                                    </td>
                                )}
                                </>
                            )}

                            {data.sector_id != 3 ? (
                                <td className='td-order-2 text-center column'>
                                <span className='d-block fs-6 py-3'>
                                    {(data.sector_id !== 3 ? 'Rp' : 'USD') +
                                    (i18next.language === 'en'
                                        ? data.fixed_price?.toLocaleString('en', {
                                            maximumFractionDigits: 4,
                                        })
                                        : data.fixed_price?.toLocaleString('id', {
                                            maximumFractionDigits: 4,
                                        })) +
                                    (data.sector_id !== 3 ? '/Ton' : '/MT')}
                                </span>
                                </td>
                            ) : (
                                <td className='td-order-2 text-center column'>
                                <span className='d-block fs-6 py-3'>
                                    USD {PriceFormater(data.fixed_price)} /MT
                                </span>
                                </td>
                            )}
                            </>
                        )}
                        {data.sector_id == 1 && (
                            <td className='td-order-2 text-center column'>
                            <span className='d-block fs-6 py-3'>
                                {data.include_ppn ? 'Include PPN' : 'Exclude PPN'}
                            </span>
                            </td>
                        )}
                        {data.sector_id == 2 ? (
                            <td className='td-order-2 text-center column'>
                            <span className='d-block fs-6 py-3'>
                                <PopoverText
                                content={data.plant_desc || '-'}
                                index={_index}
                                placement='bottom'
                                className='spec-sliceee'
                                />
                            </span>
                            </td>
                        ) : (
                            ''
                        )}
                        </tr>
                    </tbody>
                    </>
                ))}
                </table>
                {/* End Table Head */}
            </div>
        </>
    )
}

export default ApprovalSIPDetailTable